import * as React from 'react';

import { INewReviewContext } from '../../types/newReview/context';
import { defaultState } from '../../reducers/newReview';

export const NewReviewContext = React.createContext<INewReviewContext>({
  isOpened: defaultState.meta.open,
  onClose: () => {},
  goToOfferCard: () => {},
});
